import * as React from 'react'
import { NextPage } from 'next'
import { PageProps, Partner } from '../../types'

import Meta from '../Meta'
import Footer from '../Footer'
import Header from '../Header'
import PartnerHeader from '../WhiteLabel/Header'

type LayoutProps = Pick<PageProps, 'headerHTML' | 'footerHTML'> & {
  partner: Partner | null
  children: React.ReactNode
}

const Layout: NextPage<LayoutProps> = ({
  headerHTML,
  footerHTML,
  children,
  partner
}) => (
  <>
    <Meta />
    {partner ? (
      <PartnerHeader partner={partner} />
    ) : (
      <Header headerHTML={headerHTML} />
    )}
    {children}
    <Footer footerHTML={footerHTML} />
  </>
)

export default Layout
